import { Injectable } from '@angular/core';
import { catchError, map, type Observable } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { MailingAddress } from '../models/mailing-address';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from './util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from './storage.service';
import { StorageEnum } from '../enums/storage.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router } from '@angular/router';
import { Address } from '../models/address';

@Injectable({
  providedIn: 'root',
})
export class MailingAddressService {
  mailingAddressModel!: MailingAddress;
  verifyMailingAddressModel!: Address;
  constructor(
    private readonly http: HttpClient,
    private readonly utils: UtilService,
    private readonly storage: StorageService,
    private readonly router: Router,
  ) {}

  updateMailingAddress(mailingAddressData: any, accountDetail: any, isMultiAccount: boolean): Observable<any> {
    const mailingAddressRequest = this.changeMailingAddressRequest(mailingAddressData, accountDetail, isMultiAccount);
    const url = environment.OASUrl() + '/account/update-mailing-address';
    const res = this.http.post(url, mailingAddressRequest);
    return res.pipe(
      map((data: any) => {
        if (data.Error === null) {
          if (accountDetail.Person?.BillingAddress && data.Status === 'Success') {
            const newAddress = accountDetail.Person?.BillingAddress;
            newAddress.Address1 = mailingAddressRequest.AddressLine1;
            newAddress.Address2 = '';
            newAddress.City = mailingAddressRequest.City;
            newAddress.PostalCode = mailingAddressRequest.Postal;
            newAddress.State = mailingAddressRequest.State;
            this.storage.setSession(StorageEnum.AccountDetail, accountDetail);
          }
          return data.Status;
        } else {
          throw new Error(data.Error?.ErrorCode);
        }
      }),
    );
  }

  mailingAddressVerification(mailingAddressData: any): Observable<any> {
    const verifyMailingAddressRequest = this.verifyMailingAddressRequest(mailingAddressData);
    const url = environment.OASUrl() + '/account/verify-mailing-address';
    const res = this.http.post(url, verifyMailingAddressRequest).pipe(
      catchError((err) => {
        throw err;
      }),
      map((data: any) => {
        if (data.Error === null) {
          const addrList: Address[] = [];
          const addr = new Address();
          addr.Address1 = data.Address1;
          addr.Address2 = ''; // data.Address2;
          addr.City = data.City;
          addr.State = data.State;
          addr.PostalCode = data.PostalCode;
          addrList.push(addr);

          const addr2 = new Address();
          addr2.Address1 = this.verifyMailingAddressModel.Address1;
          addr2.Address2 = this.verifyMailingAddressModel.Address2;
          addr2.City = this.verifyMailingAddressModel.City;
          addr2.State = this.verifyMailingAddressModel.State;
          addr2.PostalCode = this.verifyMailingAddressModel.PostalCode;
          addrList.push(addr2);
          return addrList;
        } else {
          throw new Error(data.Error?.ErrorCode);
        }
      }),
    );
    return res;
  }

  changeMailingAddressRequest(mailingAddressData: any, accountDetail: any, isMultiAccount: boolean): any {
    this.mailingAddressModel = new MailingAddress();
    this.mailingAddressModel.AccountId = accountDetail.AccountNumber;
    this.mailingAddressModel.PersonId = this.utils.isNullOrWhitespace(accountDetail.PersonId)
      ? ''
      : accountDetail.PersonId;
    if (isMultiAccount && mailingAddressData.value.setDefault === true) {
      this.mailingAddressModel.AddressSource = 'PER';
    } else {
      this.mailingAddressModel.AddressSource = 'ACOV';
    }
    if (
      !this.utils.isNullOrWhitespace(mailingAddressData.value.address2) &&
      mailingAddressData.value.address2.length > 0
    ) {
      this.mailingAddressModel.AddressLine1 =
        mailingAddressData.value.address1.trim() + ' ' + mailingAddressData.value.address2.trim();
    } else {
      this.mailingAddressModel.AddressLine1 = mailingAddressData.value.address1.trim();
    }
    // Removes characters from address1 + 2. Allowed Chars: A-Z 0-9 '-_.
    this.mailingAddressModel.AddressLine1 = this.mailingAddressModel.AddressLine1?.replace(/[^a-zA-Z\d\-._' ]*/g, '');
    this.mailingAddressModel.AddressLine2 = '';
    this.mailingAddressModel.City = mailingAddressData.value.city.trim();
    this.mailingAddressModel.State = mailingAddressData.value.state;
    this.mailingAddressModel.Postal = mailingAddressData.value.postalCode.trim();
    this.mailingAddressModel.Country = 'USA';
    return this.mailingAddressModel;
  }

  verifyMailingAddressRequest(mailingAddressData: any): any {
    this.verifyMailingAddressModel = new Address();
    if (
      !this.utils.isNullOrWhitespace(mailingAddressData.value.address2) &&
      mailingAddressData.value.address2.length > 0
    ) {
      this.verifyMailingAddressModel.Address1 =
        mailingAddressData.value.address1.trim() + ' ' + mailingAddressData.value.address2.trim();
    } else {
      this.verifyMailingAddressModel.Address1 = mailingAddressData.value.address1.trim();
    }
    // Removes characters from address1 + 2. Allowed Chars: A-Z 0-9 '-_.
    this.verifyMailingAddressModel.Address1 = this.verifyMailingAddressModel.Address1?.replace(
      /[^a-zA-Z\d\-._' ]*/g,
      '',
    );
    this.verifyMailingAddressModel.Address2 = '';
    this.verifyMailingAddressModel.City = mailingAddressData.value.city.trim();
    this.verifyMailingAddressModel.State = mailingAddressData.value.state;
    this.verifyMailingAddressModel.PostalCode = mailingAddressData.value.postalCode.trim();
    return this.verifyMailingAddressModel;
  }
}
